<script setup lang="ts">
import { computed } from "vue";

import type { Column } from "@/models/Column";
import type { SortOrder, ToggleSort } from "@/pages/CaseSearch.vue";
import {
  SelectContent,
  SelectItem,
  SelectItemIndicator,
  SelectItemText,
  SelectPortal,
  SelectRoot,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectTrigger,
  SelectViewport,
} from "reka-ui";

interface Props {
  columns: Column[];
  sortedColumn: SortOrder;
}

withDefaults(defineProps<Props>(), {  })
const emit = defineEmits({ toggleSort: null as unknown as ToggleSort });

const value = computed({
  get: () => JSON.stringify([__props.sortedColumn.order, __props.sortedColumn.path]),
  set: (v) => {
    const [order, path] = JSON.parse(v);
    emit("toggleSort", { order, path });
  },
});
</script>

<template>
  <SelectRoot v-model="value">
    <SelectTrigger aria-label="Sort By" class="tw-btn-lg-gray">Sort by</SelectTrigger>
    <SelectPortal>
      <SelectContent
        :side-offset="4"
        position="popper"
        :avoid-collisions="true"
        class="tw-z-[100000] tw-overflow-hidden tw-rounded tw-border tw-border-gray-500 tw-bg-white tw-shadow-md"
      >
        <SelectScrollUpButton>
          <i class="fas fa-chevron-up"></i>
        </SelectScrollUpButton>
        <SelectViewport class="tw-p-2">
          <!-- <SelectItem
            :value="JSON.stringify({ order: 'desc', path: 'search.score()' })"
            class="tw-text-sm tw-relative hover:tw-cursor-pointer tw-rounded-sm tw-flex tw-items-center tw-h-7 tw-pl-5 tw-pr-3 tw-select-none tw-outline-none hover:tw-text-gray-800 focus:tw-text-gray-800 hover:tw-bg-gray-300 focus:tw-bg-gray-300"
          >
            Relevance
          </SelectItem> -->
          <template v-for="col in columns" :key="col.fieldPath">
            <SelectItem
              v-for="{ order, fallback } in [
                { order: 'desc', fallback: 'Descending' },
                { order: 'asc', fallback: 'Ascending' },
              ] satisfies Array<{ order: keyof NonNullable<typeof col.sortConfig>; fallback: string }>"
              :key="order"
              :value="JSON.stringify([order, col.fieldPath])"
              class="tw-relative tw-flex tw-h-7 tw-select-none tw-items-center tw-rounded-sm tw-pl-5 tw-pr-3 tw-text-sm tw-outline-none hover:tw-cursor-pointer hover:tw-bg-gray-300 hover:tw-text-gray-800 focus:tw-bg-gray-300 focus:tw-text-gray-800"
            >
              <SelectItemIndicator class="w-[25px] grid tw-absolute tw-left-1 tw-place-items-center">
                <i :aria-hidden="true" class="fas fa-check fa-xs"></i>
              </SelectItemIndicator>
              <SelectItemText class="tw-text-sm">
                {{ `${col.displayName[0].toUpperCase()}${col.displayName.slice(1).toLowerCase()}` }} ({{
                  (col.sortConfig?.[order] ?? fallback).toLowerCase()
                }})
              </SelectItemText>
            </SelectItem>
          </template>
        </SelectViewport>
        <SelectScrollDownButton>
          <i class="fas fa-chevron-down"></i>
        </SelectScrollDownButton>
      </SelectContent>
    </SelectPortal>
  </SelectRoot>
</template>
